import {
  CREATIVE_RICH_MSG_URL_HTTPS,
  CREATIVE_RICH_MSG_URL_FILETYPE
} from '../constants/ValidationTypes';

export const validateCreatives = theCreatives => {
  let validationErrors = {};
  theCreatives.forEach(creative => {
    const {
      data: { attachment_url: attachmentUrl, attachment_type: attachmentType },
      platform
    } = creative;
    if (attachmentUrl != null && !attachmentUrl.trim().match(/^https:\/\//)) {
      validationErrors = {
        ...validationErrors,
        [CREATIVE_RICH_MSG_URL_HTTPS]:
          'Please ensure your media URLs use https, not http.'
      };
    }
    if (
      (attachmentUrl != null && attachmentType == null) ||
      (platform === 'android' && attachmentType === 'gif')
    ) {
      validationErrors = {
        ...validationErrors,
        [CREATIVE_RICH_MSG_URL_FILETYPE]:
          'Please ensure your media URLs end with a supported filetype extension. Supported: jpeg, jpg, png, gif (on iOS only).'
      };
    }
  });
  return validationErrors;
};



// WEBPACK FOOTER //
// ./src/util/ValidationUtils.js